const specifications = [
    { id: 1, material: "Loop knit", fit: "5 sleeve", care: "Machine Wash", manufacturer: "Laynered", origin: "Made in India" },
    { id: 2, material: "Loop knit", fit: "5 sleeve", care: "Dry Clean", manufacturer: "Laynered", origin: "Made in India" },
    { id: 3, material: "Loop knit", fit: "5 sleeve", care: "Hand Wash", manufacturer: "Laynered", origin: "Made in India" },
    { id: 4, material: "Loop knit", fit: "5 sleeve", care: "Machine Wash", manufacturer: "Laynered", origin: "Made in India" },
    { id: 5, material: "Loop knit", fit: "5 sleeve", care: "Dry Clean", manufacturer: "Laynered", origin: "Made in India" },
  ];
  export default specifications;